import { type FC } from 'react'
import { ChevronLeftIcon, ArrowLongLeftIcon } from '@heroicons/react/24/outline'
import { twMerge } from 'tailwind-merge'
import { useRouter } from '@egw/router'
import { type DefaultProps, Link } from '@egw/components'
import { useTranslation } from '@egw/i18n'

export interface PageHeaderProps extends DefaultProps {
  /**
   * Header title
   */
  title?: string
  /**
   * Back link url
   */
  backLinkUrl?: string
}

export const PageHeader: FC<PageHeaderProps> = ({ title, backLinkUrl, className, id, testId, ariaLabel }) => {
  const { t } = useTranslation('features-auth')
  const { navigate } = useRouter()
  const finalClasses = twMerge('py-xs', className)

  return (
    <div
      className={finalClasses}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
    >
      {backLinkUrl ? (
        <Link href={backLinkUrl} className="md:hidden flex items-center gap-2 my-2xs">
          <ArrowLongLeftIcon className="w-5 h-5" />
          <span className="text-action text-sm font-semibold">{t('recovery.back')}</span>
        </Link>
      ) : null}

      <div className="flex items-center">
        {backLinkUrl ? (
          <button
            className="hidden md:block absolute -translate-x-14 border border-iconmuted rounded-full p-2 group cursor-pointer hover:bg-btnPrimaryBgHover hover:shadow hover:border-btnPrimaryBgHover border-iconmuted flex items-center justify-center"
            id="back-link-page-header"
            type="button"
            onClick={() => {
              navigate(backLinkUrl)
            }}
          >
            <ChevronLeftIcon id="back_link_icon" className="text-iconmuted group-hover:text-white h-5 w-5" />
          </button>
        ) : null}
        <div>
          {title ? (
            <h1 data-testid="page-header-title" className="text-header text-3xl font-light">
              {title}
            </h1>
          ) : null}
        </div>
      </div>
    </div>
  )
}
